/**
 * Položka oblíbeného formuláře s nepovinným profilem
 */
export type FavoriteMenuItem = {
    readonly formId: number;
    readonly profileId: number | undefined;
};

/**
 * Pole oblíbených položek.
 */
export type FavoriteMenuItems = readonly FavoriteMenuItem[];

/**
 * Reprezentuje část stavu menu uchovávající data o oblíbených položkách.
 */
export interface IFavoriteItemsState {
    readonly favoriteForms: FavoriteMenuItems;
}
